import { render, staticRenderFns } from "./MedalDisplay.vue?vue&type=template&id=9dfbdde8&scoped=true"
import script from "./MedalDisplay.vue?vue&type=script&lang=js"
export * from "./MedalDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dfbdde8",
  null
  
)

export default component.exports